import { memo } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useSelector } from "react-redux";
import { POSTCODE } from "../../consts/layers";
import { routeInEditSelector } from "../../reducers/matrixProfile/selectors";
import { selectedPostcodesSelector } from "../../reducers/ownApp/selectors";
import { searchHandler } from "../../reducers/ownApp/thunkActions";
import { Postcode } from "../../utils/postcode";
import { PostcodeLabel } from "../Layers/RouteLabelLayer/PostcodeLabel";
import { View } from "../View";
import { useDispatch } from "react-redux";

const useStyles = makeStyles({
  mainContainer: {
    display: "flex",
    overflowX: "auto",
  },
  container: {
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
    marginRight: "10px",
    flexWrap: "nowrap",
  },
  spacing: {
    padding: "2px",
    flexWrap: "nowrap",
  },
});

export const AffectedPostcodesList = memo(() => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const selectedPostcodes = useSelector(selectedPostcodesSelector);
  const routeInEdit = useSelector(routeInEditSelector);

  if (!Array.isArray(selectedPostcodes) || !selectedPostcodes.length)
    return null;

  const goToPostcode = ({ postcode }) =>
    dispatch(
      searchHandler({
        item: {
          type: Postcode.getLevel(postcode),
          value: postcode,
        },
        type: POSTCODE,
      })
    );

  return (
    <View className={styles.mainContainer}>
      {[...selectedPostcodes].sort().map((postcode, index) => (
        <PostcodeLabel
          key={index}
          postcode={postcode}
          colour={routeInEdit.colour}
          textColour={routeInEdit.textColour}
          onClick={goToPostcode}
        />
      ))}
    </View>
  );
});
